import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { Typography, CircularProgress } from '@material-ui/core';
import { constants } from "../Helpers/constantsFile";

const ChurnTrack = () => {
  const [userTrans, setUserTrans] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const today = new Date();
  const token = useSelector(state => state.token.token);

  const readUserTrans = () => {
    return axios.get(`${constants.baseUrl}/user-transactions`, {
      headers: {
        'authorization': token,
      },
    }).then((res) => {
      setUserTrans(res?.data?.data?.transactions || []);
    }).catch((err) => {
      alert(err?.response?.data?.message);
    });
  };

  const readUsers = () => {
    return axios.get(`${constants.baseUrl}/users`, {
      headers: {
        'authorization': token,
      },
    }).then((res) => {
      setUsers(res?.data?.data?.users || []);
    }).catch((err) => {
      alert(err?.response?.data?.message);
    });
  };

  useEffect(() => {
    Promise.all([readUserTrans(), readUsers()]).then(() => {
      setLoading(false);
    });
  }, []);

  const currentMonth = moment(today).format("YYYY-MM");
  const lastMonth = moment(today).subtract(1, 'months').format("YYYY-MM");

  const currentMonthTrans = userTrans.filter(tran => 
    moment(tran.date).format("YYYY-MM") === currentMonth && tran.description?.substring(0, 7) === "Monthly"
  );

  const lastMonthTrans = userTrans.filter(tran => 
    moment(tran.date).format("YYYY-MM") === lastMonth && tran.description?.substring(0, 7) === "Monthly"
  );

  const currentMonthUserIds = new Set(currentMonthTrans.map(tran => tran.user?._id));
  const lastMonthUserIds = new Set(lastMonthTrans.map(tran => tran.user?._id));

  const userCreatedBeforeLastMonth = (user) => {
    const userCreationDate = moment(user?.created_at);
    const startOfLastMonth = moment().subtract(1, 'months').startOf('month');
  
    return userCreationDate.isBefore(startOfLastMonth);
  };

  const churnedUsers = users.filter(user => 
    !currentMonthUserIds.has(user?._id) &&
    lastMonthUserIds.has(user?._id) &&
    userCreatedBeforeLastMonth(user) &&
    user?.notify == "stuck"
  );

  const userCreatedLastMonth = (user) => {
    const userCreationDate = moment(user?.created_at);
    const startOfLastMonth = moment().subtract(1, 'months').startOf('month');
    const endOfLastMonth = moment().subtract(1, 'months').endOf('month');
  
    return userCreationDate.isBetween(startOfLastMonth, endOfLastMonth, 'day', '[]');
  };

  const leftUsers = users?.filter(user => 
    !currentMonthUserIds.has(user?._id) &&
    lastMonthUserIds.has(user?._id) &&
    userCreatedLastMonth(user) &&
    user?.notify == "stuck"
  );

  if (loading) {
    return (
      <div style={{ width: "93%", margin: "20px auto", textAlign: "center" }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <div style={{ width: "93%", margin: "20px auto", display: "flex", gap: "40px", flexDirection: "column" }}>
      <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "12px" }}>
        <Typography style={{ fontSize: "18px", fontWeight: "bold",  }}>
          Churned Users
        </Typography>
        <Typography style = {{
            fontSize: "16px", color: "#6D6D6D"
        }}> Macaamiisha aan bixin bishaan, oo bixisay bishi lasoo dhaafay, oo la abuuray ka hor bishi lasoo dhaafay</Typography>
        {churnedUsers.length === 0 ? (
          <Typography>No data</Typography>
        ) : (
          churnedUsers.map((user, index) => (
            <div key={user.id} style={{ display: "flex", cursor: "pointer", flexDirection: "row", padding: "15px", alignItems: "center", borderRadius: "10px", background: "white" }}>
              <Typography style={{ fontSize: "16px", flex: 0.2, color: "grey" }}>{index + 1}.</Typography>
              <Typography style={{ fontSize: "16px", flex: 2 }}>{user.name}</Typography>
              <Typography style={{ fontSize: "16px", flex: 1 }}>{user.phone}</Typography>
              <Typography style={{ fontSize: "16px", flex: 1 }}>{user.notify}</Typography>
              <Typography style={{ fontSize: "16px", flex: 1 }}>{moment(user.created_at).format("YYYY-MM-DD")}</Typography>
            </div>
          ))
        )}
      </div>

      <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "12px" }}>
        <Typography style={{ fontSize: "18px", fontWeight: "bold", color: "#6D6D6D" }}>
          Users Who Left
        </Typography>
        <Typography style = {{
            fontSize: "16px", color: "#6D6D6D"
        }}> Macaamiisha aan bixin bishaan, oo bixisay bishi lasoo dhaafay, oo la abuuray bishi lasoo dhaafay</Typography>
        {leftUsers.length === 0 ? (
          <Typography>No data</Typography>
        ) : (
          leftUsers.map((user, index) => (
            <div key={user.id} style={{ display: "flex", cursor: "pointer", flexDirection: "row", padding: "15px", alignItems: "center", borderRadius: "10px", background: "white" }}>
              <Typography style={{ fontSize: "16px", flex: 0.2, color: "grey" }}>{index + 1}.</Typography>
              <Typography style={{ fontSize: "16px", flex: 2 }}>{user.name}</Typography>
              <Typography style={{ fontSize: "16px", flex: 1 }}>{user.phone}</Typography>
              <Typography style={{ fontSize: "16px", flex: 1 }}>{user.notify}</Typography>
              <Typography style={{ fontSize: "16px", flex: 1 }}>{moment(user.created_at).format("YYYY-MM-DD")}</Typography>
            </div>
          ))
        )}
      </div>
      <SmsBuyers />
    </div>
  );
};

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { useSelector } from 'react-redux';
// import moment from 'moment';
// import { Typography, CircularProgress } from '@material-ui/core';
// import { constants } from "../Helpers/constantsFile";

const SmsBuyers = () => {
  const [userTrans, setUserTrans] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = useSelector(state => state.token.token);

  const readUserTrans = () => {
    return axios.get(`${constants.baseUrl}/user-transactions`, {
      headers: {
        'authorization': token,
      },
    }).then((res) => {
      setUserTrans(res?.data?.data?.transactions || []);
    }).catch((err) => {
      alert(err?.response?.data?.message);
    });
  };

  const readUsers = () => {
    return axios.get(`${constants.baseUrl}/users`, {
      headers: {
        'authorization': token,
      },
    }).then((res) => {
      setUsers(res?.data?.data?.users || []);
    }).catch((err) => {
      alert(err?.response?.data?.message);
    });
  };

  useEffect(() => {
    Promise.all([readUserTrans(), readUsers()]).then(() => {
      setLoading(false);
    });
  }, []);

  // Filter SMS transactions
  const smsTrans = userTrans.filter(tran => tran.description?.substring(0, 3) === "SMS");

  // Aggregate SMS purchases by user
  const smsCounts = smsTrans.reduce((acc, tran) => {
    if (tran.user && tran.user._id) {
      acc[tran.user._id] = (acc[tran.user._id] || 0) + tran.credit;
    }
    return acc;
  }, {});

  // Create a ranked list of users
  const rankedUsers = Object.keys(smsCounts)
    .map(userId => {
      const user = users.find(u => u._id === userId);
      return {
        ...user,
        totalSms: smsCounts[userId],
      };
    })
    .sort((a, b) => b.totalSms - a.totalSms);

    let totalSms = 0
    rankedUsers?.map(user => {
      totalSms += user?.totalSms
    })

  if (loading) {
    return (
      <div style={{ width: "93%", margin: "20px auto", textAlign: "center" }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <div style={{ width: "100%", margin: "20px auto", display: "flex", gap: "40px", flexDirection: "column" }}>
      <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "12px" }}>
        <Typography style={{ fontSize: "18px", fontWeight: "bold" }}>
          Top SMS Buyers
        </Typography>
        <Typography style={{ fontSize: "16px", color: "#6D6D6D" }}>
          Users who bought the most SMS (${totalSms} sold since waafi)
        </Typography>
        {rankedUsers.length === 0 ? (
          <Typography>No data</Typography>
        ) : (
          rankedUsers.map((user, index) => (
            <div key={user._id} style={{ display: "flex", cursor: "pointer", flexDirection: "row", padding: "15px", alignItems: "center", borderRadius: "10px", background: "white" }}>
              <Typography style={{ fontSize: "16px", flex: 0.2, color: "grey" }}>{index + 1}.</Typography>
              <Typography style={{ fontSize: "16px", flex: 2 }}>{user.name}</Typography>
              <Typography style={{ fontSize: "16px", flex: 1 }}>{user.phone}</Typography>
              <Typography style={{ fontSize: "16px", flex: 1 }}>{user.smsName}</Typography>
              <Typography style={{ fontSize: "16px", flex: 1 }}>${user.totalSms}</Typography>
            </div>

          ))
        )}
      </div>
    </div>
  );
};

export default ChurnTrack;
